<template>
  <div class="step-navigation mt-8 pt-6 border-t border-gray-200">
    <!-- Boutons de navigation -->
    <div class="nav-buttons">
      <!-- Bouton Suivant -->
      <ActionButton
        v-if="currentStep < totalSteps - 1"
        variant="primary"
        size="lg"
        :disabled="!canProceed" 
        @click="$emit('next')"
        label="Suivant"
        icon="fas fa-arrow-right"
      />
      
      <!-- Bouton de soumission final -->
      <ActionButton
        v-if="currentStep === totalSteps - 1"
        variant="success"
        size="lg"
        type="submit"
        :disabled="!canSubmit"
        :loading="isLoading"
        :label="submitLabel"
        icon="fas fa-check"
      />
    </div>
    
    <!-- Bouton Précédent -->
    <div class="prev-button">
      <ActionButton
        v-if="currentStep > 0"
        variant="secondary"
        size="lg"
        @click="$emit('previous')"
        label="Précédent"
        icon="fas fa-arrow-left"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ActionButton from '@/components/ui/ActionButton.vue';

import type { StepNavigationProps } from '@/types/sellerRegister';

withDefaults(defineProps<StepNavigationProps>(), {
  isLoading: false,
  submitLabel: 'Soumettre'
});

defineEmits<{
  previous: [];
  next: [];
}>();
</script>

<style scoped>
.step-navigation {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.prev-button {
  width: 100%;
  order: 2; /* Mobile: Précédent en bas */
}

.nav-buttons {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
  order: 1; /* Mobile: Navigation en haut */
}

/* Desktop styles */
@media (min-width: 640px) {
  .step-navigation {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  
  .prev-button {
    width: auto;
    order: 1; /* Desktop: Précédent à gauche */
  }
  
  .nav-buttons {
    flex-direction: row;
    width: auto;
    order: 2; /* Desktop: Navigation à droite */
  }
}
</style>
